import { Mic, Music, Sparkles, Users, Flame, Wand2, Baby, Cpu, Theater, HeartHandshake } from "lucide-react";

const entertainmentForms = [
  { icon: Mic, title: "Stand-up i kabaret", description: "Profesjonalni komicy z materiałem dopasowanym do branży i charakteru wydarzenia." },
  { icon: Music, title: "Oprawa muzyczna", description: "Zespoły, DJ-e, śpiew operowy i show muzyczne na żywo dla każdego formatu." },
  { icon: Sparkles, title: "Pokazy taneczne", description: "Widowiskowe choreografie - od latino i salsy po pokazy LED i akrobatyczne." },
  { icon: Wand2, title: "Iluzja i magia", description: "Pokazy iluzjonistyczne, close-up magic i spektakularne triki sceniczne." },
  { icon: Flame, title: "Widowiska sceniczne", description: "Pokazy ognia, laserów, pirotechniki i efektów specjalnych." },
  { icon: Theater, title: "Aktorstwo i improwizacja", description: "Teatr impro, skecze, parodie i interaktywne formy sceniczne." },
  { icon: HeartHandshake, title: "Integracja i team building", description: "Warsztaty, gry zespołowe i aktywności budujące relacje w firmie." },
  { icon: Baby, title: "Atrakcje dla dzieci", description: "Animatorzy, klauni, teatrzyki i warsztaty kreatywne na eventy rodzinne." },
  { icon: Cpu, title: "Technologia i AI", description: "Pokazy robotów, dronów, strefa VR i warsztaty ze sztuczną inteligencją." },
  { icon: Users, title: "Konferansjerka i prowadzenie", description: "Doświadczeni konferansjerzy i prowadzący, którzy nadadzą rytm wydarzeniu." },
];

export const FormsOfComedy = () => {
  return (
    <section className="py-24 section-white relative overflow-hidden">
      <div className="absolute inset-0 dot-pattern opacity-20" />
      <div className="container relative z-10">
        <h2 className="text-4xl md:text-5xl font-outfit font-bold text-center mb-4 text-foreground">
          Rodzaje <span className="text-gradient">rozrywki</span>
        </h2>
        <p className="text-muted-foreground text-center mb-16 max-w-md mx-auto">
          Różnorodne formaty na każdy typ wydarzenia
        </p>
        <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-5">
          {entertainmentForms.map((form) => {
            const Icon = form.icon;
            return (
              <div key={form.title} className="card-elevated p-6 hover:border-primary/20 hover:-translate-y-1 group">
                <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center mb-3 group-hover:bg-primary/15 transition-colors">
                  <Icon className="w-5 h-5 text-primary" />
                </div>
                <h3 className="text-base font-outfit font-bold mb-1.5 text-foreground">{form.title}</h3>
                <p className="text-muted-foreground text-sm leading-relaxed">{form.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
